import { lazyLoad } from 'app/utils/loadable'

export const SoftwareDownloadPage = lazyLoad(
  () => import('./index'),
  module => module.SoftwareDownloadPage
)
